module.exports = __webpack_public_path__ + "img/qq8.e1e2922d.jpg";